import * as actions from './new-actions'
import mutations from './mutations'
import defaultHeadImg from '@/assets/images/defaultHeadImg2.png'

/**
 * 呼叫中心状态管理
 * @type {{state: {}, mutations: {}, actions: {}}}
 */
const callCenter = {
  namespaced: true,
  state: {
    isLogin: false,
    imLogin: false,
    im: {
      userSig: '',
      ready: false
    },
    startTime: '',
    sessionId: '',
    creactsessionPara: {
      engineer_code: '',
      engineer_name: '',
      engineer_img: ''
    },
    loginInfo: {
      cube_uid: '',
      token: ''
    },
    userInfo: {
      cube_uid: '',
      user_name: '客户',
      queue_code: 'webchat_5cf7289acebc9',
      avatar: defaultHeadImg // getRandomHeadImage()
    },
    historyMsgList: [],
    historyMsg: [],
    message: [],
    screen: '',
    audioPlaying: false // 播放语音时，全局只能有一个正在播放的
  },
  actions: {
    ...actions
  },
  mutations: {
    ...mutations
  }
}
export default callCenter



// WEBPACK FOOTER //
// ./src/store/modules/call-center/index.js